import script from "./SideMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenu.vue?vue&type=style&index=0&id=5aeb5f0b&lang=scss&scoped=true"
import "./SideMenu.vue?vue&type=style&index=1&id=5aeb5f0b&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aeb5f0b"]])

export default __exports__